<div class="error-retry">
  <div>{{ text }}</div>
  @if (icon) {
    <div>
      <svg class="error-retry__icon" ftrIcon="ErrorCircleSolid" iconColor="GreyLighter" [iconSize]="28" />
    </div>
  }
  <div><button ftrButton displayType="text" (click)="onRetry()">Try again</button></div>
</div>
